'use client';

import Link from 'next/link';
import { useCallback, useEffect, useState } from 'react';
import { type AuthState, goToLoginPage, loadAuthState, signOut } from '@/lib/auth';
import { useTranslation } from '@/lib/i18n';

export default function Nav() {
  const { t } = useTranslation();
  const [state, setState] = useState<AuthState>({ status: 'loading' });

  useEffect(() => {
    void loadAuthState().then(setState);
  }, []);

  // WHY: hoist the inline handler so it is not recreated on every render
  // (react-perf/jsx-no-new-function-as-prop) and stays stable for the button.
  const handleSignOut = useCallback((): void => {
    void signOut();
  }, []);

  return (
    <nav className='flex items-center justify-between border-b border-border px-6 py-4'>
      <Link href='/' className='text-xl font-bold'>
        {t('app.title')}
      </Link>
      <div>
        {state.status === 'loading' && (
          <span className='text-sm opacity-60'>{t('nav.ellipsis')}</span>
        )}
        {state.status === 'anonymous' && (
          <button
            type='button'
            onClick={goToLoginPage}
            className='rounded border border-border px-3 py-1 text-sm'
          >
            {t('nav.signIn')}
          </button>
        )}
        {state.status === 'authenticated' && (
          <div className='flex items-center gap-3'>
            <span className='text-sm'>{state.user.display_name ?? state.user.email}</span>
            <button
              type='button'
              onClick={handleSignOut}
              className='rounded border border-border px-3 py-1 text-sm'
            >
              {t('nav.signOut')}
            </button>
          </div>
        )}
      </div>
    </nav>
  );
}
